import "./Footer.css";

function Footer(){
    return(
        <div className="footer">
            <footer className="footer-content">
                <div className="footer-row">

                    <div className="footer-col left">
                        <p>
                            <p className="footer-bold">Ethan Hair</p>
                            Software Developer <br />
                            <a href="mailto:ethanhair37@gmail.com">ethanhair37@gmail.com</a>
                        </p>
                    </div>

                    <div className="footer-col center">
                        <p className="footer-bold">Page Links</p>
                        <a href="/about" className="page-links">About</a>
                        <a href="/contact" className="page-links">Contact</a>
                    </div>

                    <div className="footer-col right">
                        <a href="https://github.com/ethanhairy/ethanhair-projects" target="_blank" rel="noopener noreferrer">
                            <i className="fa-brands fa-github fa-2x"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/ethan-hair-a3350a392" target="_blank" rel="noopener noreferrer">
                            <i className="fa-brands fa-linkedin fa-2x"></i>
                        </a>
                    </div>

                </div>
            </footer>
        </div>
    );
}

export default Footer;